import dayjs from "dayjs";

export const disableFutureDates = (current: any) => {
    return current && current > dayjs().endOf('day');
  };